export default [
  '2x1x1x',
  '1x1x1x1x',
  '2x2x',
  '1x1x2x'
]
